import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery, showNotification } from "@/services/api";
import { ListResponse } from "@/types/response.type";
import { Rental, RentalExpired, RentalForm, TenantsExpired } from "@/types/rental.type";

export const rentalApi = createApi({
  reducerPath: "rentalApi",
  baseQuery,
  tagTypes:['rentals'],
  endpoints: (builder) => ({
    getRentals: builder.query<ListResponse<Rental>, {}>({
      query: (data) => ({ url: `rental`, params: data }),
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: ListResponse<Rental> }, meta) => {
        return rawResult.data
      },
    }),
    getRentalsExpired: builder.query<RentalExpired, {}>({
      query: () => `rental/expired`,
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: RentalExpired }, meta) => {
        return rawResult.data
      },
    }),
    getTenantExpired: builder.query<TenantsExpired, {}>({
      query: () => `rental/tenant-expired`,
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: TenantsExpired }, meta) => {
        return rawResult.data
      },
    }),
    getRental: builder.query<Rental, string>({
      query: (id) => `rental/${id}`,
      keepUnusedDataFor: 0,
      transformResponse: (rawResult: { data: Rental }, meta) => {
        return rawResult.data
      },
    }),
    addRental: builder.mutation<any, RentalForm>({
      query: (body) => ({
        url: 'rental',
        method: 'POST',
        body,
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("POST", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("POST", "error", err?.error?.data?.message || "error")
        }
      }
    }),
    editRental: builder.mutation<Rental, Pick<Rental, "id">>({
      query: ({ id, ...body }) => ({
        url: `rental/${id}`,
        method: 'PUT',
        body,
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("PUT", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("PUT", "error", err?.error?.data?.message || "error")
        }
      }
    }),
    deleteRental: builder.mutation<any, string>({
      query: (id) => ({
        url: `rental/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("DELETE", "success")
        } catch (err: any) {
          
          // `onError` side-effect
          showNotification("DELETE", "error", err?.error?.data?.message || "error")
        }
      }
    }),
  }),
});

export const { useGetRentalsQuery, useGetRentalQuery, useGetRentalsExpiredQuery, useGetTenantExpiredQuery, useAddRentalMutation, useEditRentalMutation, useDeleteRentalMutation } = rentalApi;
